import { mapGetters, mapState } from 'vuex'
import debounce from 'lodash/debounce'

import { getAddressResume } from '@/filters/address'
import rankingClickedEvent from '@/utils/tracking/results/ranking-clicked'
import { SUBJECTS } from '@/utils/constants'
import { EXPANSIONS } from '@/utils/constants/results'

import getUrl from '@/mixins/get-url'
import getImageDescription from '@/mixins/get-image-description'
import localStorage from '@/storage/local-storage'

export default {
  props: {
    account: { type: Object, required: true },
    businessTypeContext: { type: String },
    index: { type: Number, required: true },
    listing: { type: Object, required: true },
    listingType: { type: String, default: '' },
    page: { type: String, default: 'results' },
    screen: { type: String, default: '' }, // for tracking purposes
    showPrice: { type: Boolean, default: true },
    url: { type: String, required: true },
    shouldRenderAsLink: { type: Boolean, default: false },
    selected: { type: Boolean },
    preloadFirstImg: { type: Boolean },
  },

  mixins: [getUrl, getImageDescription],

  data () {
    return {
      descriptionOpened: false,
      visitedListing: false,
    }
  },

  beforeUpdate () {
    const seenListing = localStorage.getSeenListings()
    const isVisitedListing = seenListing.length
      && seenListing.some((item) => item === this.listing.id)

    this.visitedListing = isVisitedListing
  },

  computed: {
    ...mapState({
      glossary: (state) => state.context.glossary,
      results: (state) => state.results,
    }),

    ...mapGetters({
      currentPlatform: 'currentPlatform',
      device: 'device',
    }),

    address () {
      const { address } = this.listing
      return getAddressResume({ address })
    },

    stamps () {
      const { stamps } = this.listing
      return stamps || []
    },

    imageProps () {
      const {
        address: alt,
        listing,
        glossary,
        sizeResponsive: { imageSize },
        screen,
        type,
        account,
      } = this

      return {
        class: [
          'simple-card__gallery',
          'card-listing__image',
          'card-dynamic__image',
        ],
        props: {
          ...imageSize,
          listing,
          glossary,
          carouselActive: true,
          alt,
          description: this.$getImageDescription,
          screen,
          type,
          account,
        },
      }
    },

    infoWrapperProps () {
      const { guttersContent } = this

      return {
        class: 'simple-card__box',
        props: {
          display: 'flex',
          direction: 'column',
          gutter: guttersContent,
        },
      }
    },
  },

  methods: {
    shouldOpenInNewTab (e, options) {
      return [e?.metaKey, e?.ctrlKey, options.newTab].some(Boolean)
    },

    goTo: debounce(function (e, options = {}) {
      const action = options.action || e?.currentTarget?.getAttribute('data-action')

      if (options.track) {
        options.track()
      } else {
        this.track(action)
      }

      localStorage.setSeenListings(this.listing.id)
      this.visitedListing = true

      const { path, query } = this.$getUrl
      const hash = options.hash ? `#${options.hash}` : ''

      if (this.shouldOpenInNewTab(e, options)) {
        const variationQuery = query.__zt ? `?__zt=${query.__zt}` : ''
        window.open(`${path}${hash}${variationQuery}`, '_blank', 'noopener')
      } else {
        this.$router.push({
          path,
          query,
        })
      }
    }, 1000, { leading: true, trailing: false }),

    trackingRankingClicked (action) {
      rankingClickedEvent({
        account: this.account,
        results: this.$store.state[this.page],
        listing: this.listing,
        listingPosition: this.index + 1,
        expandedResultType: this.expandedResultType(),
        defaulterAdvertiser: this.defaulterAdvertiser(),
        action,
      })
    },

    track (action) {
      this.$emit('card-listing:click', this.listing)
      this.trackingRankingClicked(action)
    },

    expandedResultType () {
      return EXPANSIONS[this.listingType] || null
    },

    defaulterAdvertiser () {
      if (this.listing.isDefaulterInactive) return SUBJECTS.LEAD.DEFAULTER_ADVERTISER
      return null
    },
  },
}
